module.exports = __webpack_public_path__ + "img/button-shopee.1f438f44.png";